<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/sale-return-products">
                    <icon name="undo-alt"></icon>
                    คืนสินค้า
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
//    import OrderList from "../../components/Order/Order/OrderList";
//    import InvoiceForm from "../../components/Order/Invoice/InvoiceForm";


    export default {
        components: {
//            InvoiceForm,
//            OrderList,
        },
        name: "sale-return-products-layout"
    };
</script>

<style lang="scss" scoped></style>
